import { NgModule } from '@angular/core';

import { SpInputComponent } from '@components/sp-form-controls/sp-input/sp-input.component';
import { SpInputNumComponent } from '@components/sp-form-controls/sp-input-num/sp-input-num.component';

const STANDALONE_COMPONENTS = [SpInputComponent, SpInputNumComponent];

@NgModule({
    imports: [...STANDALONE_COMPONENTS],
    exports: [...STANDALONE_COMPONENTS],
})
export class SpFormControlsModule {}
